import { render, staticRenderFns } from "./DragAndDrop.vue?vue&type=template&id=c99d3b1a&scoped=true&"
import script from "./DragAndDrop.vue?vue&type=script&lang=js&"
export * from "./DragAndDrop.vue?vue&type=script&lang=js&"
import style0 from "./DragAndDrop.vue?vue&type=style&index=0&id=c99d3b1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99d3b1a",
  null
  
)

export default component.exports